export const CONFIRM_APPOINTMENT = 'CONFIRM_APPOINTMENT';
export const CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT';
export const EMAIL_APPOINTMENT = 'EMAIL_APPOINTMENT';
export const GET_ALL_SLOTS = 'GET_ALL_SLOTS';
export const GET_APPOINTMENT_MESSAGE_RECIPIENTS = 'GET_APPOINTMENT_MESSAGE_RECIPIENTS';
export const GET_FILTER = 'GET_FILTER';
export const GET_FILTER_LABELS = 'GET_FILTER_LABELS';
export const GET_DEFAULT_EMAIL_RECIPIENT = 'GET_DEFAULT_EMAIL_RECIPIENT';
export const GET_PAST_APPOINTMENTS = 'GET_PAST_APPOINTMENTS';
export const GET_UPCOMING_APPOINTMENTS = 'GET_UPCOMING_APPOINTMENTS';
export const REQUEST_APPOINTMENT = 'REQUEST_APPOINTMENT';
export const SEND_APPOINTMENT_MESSAGE = 'SEND_APPOINTMENT_MESSAGE';
export const GET_APPOINTMENT_TIME_RANGE = 'GET_APPOINTMENT_TIME_RANGE';




// WEBPACK FOOTER //
// ./src/actions/appointments/types.js